import { Point } from "../../../Utils/Point";
import { AbstractBgTileModel } from "./AbstractBgTileModel";

export class BgCloudCityTileModel extends AbstractBgTileModel {
    readonly width = 5800;
    pos = new Point();
}